(function () {
  const EVENT_NAME = 'preorder:dates-updated';

  const toNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const formatIsoDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatDisplayDate = (date) =>
    date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    });

  const addDays = (base, days) => {
    const date = new Date(base);
    date.setDate(date.getDate() + days);
    return date;
  };

  const calculateWindows = (settings, now = new Date()) => {
    const cutoffHour = toNumber(settings.cutoffHour, 17);
    const anchor = new Date(now);
    if (anchor.getHours() >= cutoffHour) {
      anchor.setDate(anchor.getDate() + 1);
    }
    anchor.setHours(0, 0, 0, 0);

    const shipMin = toNumber(settings.shipMinDays, 15);
    const shipMax = toNumber(settings.shipMaxDays, 30);
    const transitMin = toNumber(settings.transitMinDays, 7);
    const transitMax = toNumber(settings.transitMaxDays, 15);

    const shipStart = new Date(anchor);
    shipStart.setDate(anchor.getDate() + shipMin);
    const shipEnd = new Date(anchor);
    shipEnd.setDate(anchor.getDate() + shipMax);
    const deliveryStart = addDays(shipStart, transitMin);
    const deliveryEnd = addDays(shipEnd, transitMax);

    return {
      anchor,
      shipStart,
      shipEnd,
      deliveryStart,
      deliveryEnd,
      shipWindowIso: `${formatIsoDate(shipStart)} - ${formatIsoDate(shipEnd)}`,
    };
  };

  const getSettings = (productForm) => ({
    shipMinDays: productForm.dataset.preorderShipMinDays,
    shipMaxDays: productForm.dataset.preorderShipMaxDays,
    transitMinDays: productForm.dataset.preorderTransitMinDays,
    transitMaxDays: productForm.dataset.preorderTransitMaxDays,
    cutoffHour: productForm.dataset.preorderCutoffHour,
  });

  const setEnabled = (input, enabled) => {
    if (!input) return;
    input.disabled = !enabled;
  };

  const syncProductFormFromRenderedSection = (event) => {
    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    if (!sectionId || !html) return null;

    const current = document.querySelector(`product-form[data-section-id="${sectionId}"]`);
    const rendered = html.querySelector(`product-form[data-section-id="${sectionId}"]`);
    if (!current || !rendered) return current;

    Object.entries(rendered.dataset).forEach(([key, value]) => {
      current.dataset[key] = value;
    });

    return current;
  };

  const updateProductPreorder = (productForm) => {
    if (!productForm) return;

    const isPreorder = productForm.dataset.preorderActive === 'true';
    const label = productForm.dataset.preorderButtonLabel || 'PRE-ORDER';
    const submitText = productForm.querySelector('.product-form__submit span');
    const paymentButton = productForm.querySelector('.shopify-payment-button');
    const dateLine = productForm.querySelector('[data-preorder-dates]');
    const preorderInput = productForm.querySelector('[name="properties[_preorder]"]');
    const shipWindowInput = productForm.querySelector('[name="properties[_ship_window]"]');
    const badge = document.querySelector('[data-preorder-badge]');

    if (submitText && isPreorder) {
      submitText.textContent = label;
    }

    if (paymentButton) {
      paymentButton.hidden = isPreorder;
    }

    if (badge) {
      badge.hidden = !isPreorder;
      badge.textContent = label;
    }

    setEnabled(preorderInput, isPreorder);
    setEnabled(shipWindowInput, isPreorder);

    if (!isPreorder) {
      if (dateLine) {
        dateLine.hidden = true;
        dateLine.textContent = '';
      }
      if (preorderInput) preorderInput.value = '';
      if (shipWindowInput) shipWindowInput.value = '';
      return;
    }

    const windows = calculateWindows(getSettings(productForm));
    if (preorderInput) preorderInput.value = 'true';
    if (shipWindowInput) shipWindowInput.value = windows.shipWindowIso;
    if (dateLine) {
      dateLine.hidden = false;
      dateLine.textContent = `Ship out ${formatDisplayDate(windows.shipStart)} - ${formatDisplayDate(
        windows.shipEnd
      )}. Estimated delivery ${formatDisplayDate(windows.deliveryStart)} - ${formatDisplayDate(windows.deliveryEnd)}.`;
    }

    productForm.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        bubbles: true,
        detail: windows,
      })
    );
  };

  const init = () => {
    document.querySelectorAll('product-form[data-preorder-active]').forEach(updateProductPreorder);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        updateProductPreorder(syncProductFormFromRenderedSection(event));
      });
    }
  };

  window.Section444Preorder = {
    calculateWindows,
    formatIsoDate,
    updateProductPreorder,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
